"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _style = require("./style");

var _icons = require("../../../static/icons/icons");

var _palette = require("../../../styles/palette");

var _Icon = _interopRequireDefault(require("../../atoms/Icon"));

var BookingConfirmation = function BookingConfirmation(_ref) {
  var color = _ref.color,
      code = _ref.code,
      icon = _ref.icon,
      title = _ref.title,
      subtitle = _ref.subtitle;
  return _react["default"].createElement(_style.Container, {
    "data-test-id": "bookingConfirmation"
  }, _react["default"].createElement(_Icon["default"], {
    icon: icon,
    size: 37,
    color: color
  }), _react["default"].createElement(_style.Title, {
    color: color
  }, title), _react["default"].createElement(_style.Subtitle, {
    color: color
  }, subtitle), _react["default"].createElement(_style.Code, {
    color: color
  }, code));
};

BookingConfirmation.propTypes = {
  icon: _propTypes["default"].string,
  color: _propTypes["default"].string,
  title: _propTypes["default"].string,
  subtitle: _propTypes["default"].string,
  code: _propTypes["default"].string.isRequired
};
BookingConfirmation.defaultProps = {
  icon: _icons.ICONS.PLANE,
  color: _palette.palette.white,
  title: 'Your booking is done!',
  subtitle: 'Your booking code:'
};
var _default = BookingConfirmation;
exports["default"] = _default;